module.exports = __webpack_public_path__ + "img/loan.f42dfd44.png";